import type { CreditsBreakdown } from '@leadgen/models/server'

type VolumeDiscountTier = Exclude<
  keyof CreditsBreakdown,
  'totalCredits' | 'totalAmount' | 'promotionalCredits'
>
type VolumeDiscountPolicy = Record<
  VolumeDiscountTier,
  { from: number; to: number | null; pencePerCredit: number }
>

export const volumeDiscountPolicy: VolumeDiscountPolicy = {
  tier1: { from: 0, to: 40, pencePerCredit: 300 },
  tier2: { from: 41, to: 100, pencePerCredit: 275 },
  tier3: { from: 101, to: 150, pencePerCredit: 250 },
  tier4: { from: 151, to: 200, pencePerCredit: 230 },
  tier5: { from: 201, to: null, pencePerCredit: 220 },
}
